import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import autoFocus from '../modifiers/auto-focus.js';
import autoShowModal from '../modifiers/auto-show-modal.js';

export default class PermissionDialog extends Component {
  @service intl;

  @action onSubmit(e) {
    const formData = new FormData(e.currentTarget);
    const permission = Object.fromEntries(formData.entries());
    this.args.onSubmit(permission);
  }

  <template>
    <dialog
      class="modal"
      {{autoShowModal}}
      {{on "cancel" @onClose}}
      {{on "close" @onClose}}
    >
      <form
        aria-label="modal"
        method="dialog"
        class="modal-box"
        {{on "submit" this.onSubmit}}
      >
        <h3 class="text-lg font-bold mb-2">
          {{t (if @model "permissions.edit" "permissions.new")}}
        </h3>

        <fieldset class="fieldset w-full">
          <legend class="fieldset-legend">{{t "permissions.subject"}}</legend>
          <input
            name="subject"
            type="text"
            required
            value={{@model.subject}}
            class="input input-bordered w-full"
            {{autoFocus}}
          />
        </fieldset>

        <fieldset class="fieldset w-full">
          <legend class="fieldset-legend">{{t "permissions.permission"}}</legend>
          <input
            name="permission"
            type="text"
            required
            value={{@model.permission}}
            class="input input-bordered w-full"
          />
        </fieldset>

       <fieldset class="fieldset w-full">
          <legend class="fieldset-legend">{{t "permissions.object-type"}}</legend>
          <input
            name="objectType"
            type="text"
            required
            value={{@model.objectType}}
            class="input input-bordered w-full"
          />
        </fieldset>

        <fieldset class="fieldset w-full">
          <legend class="fieldset-legend">{{t "permissions.object"}}</legend>
          <input
            name="object"
            type="text"
            required
            value={{@model.object}}
            class="input input-bordered w-full"
          />
        </fieldset>

        <div class="modal-action">
          <button type="submit" class="btn btn-primary uppercase">
            {{t (if @model "update" "create")}}
          </button>
        </div>
      </form>

      <form aria-label="backdrop" method="dialog" class="modal-backdrop">
        <button type="submit" />
      </form>
    </dialog>
  </template>
}
